import { useTranslations } from "next-intl";

function FooterLegal() {
  const t = useTranslations("common");

  return (
    <div className="d-flex gap-2 align-items-center justify-content-between footer-legal">
      <a
        href={t("footer.conditions.link")}
        className="link-primary footer-legal-link"
        title={t("footer.conditions.text")}
      >
        {t("footer.conditions.text")}
      </a>
      <p className="mb-0 font-size-sm text-middle-gray">|</p>
      <a
        href={t("footer.mentions.link")}
        className="link-primary footer-legal-link"
        title={t("footer.mentions.text")}
      >
        {t("footer.mentions.text")}
      </a>
    </div>
  );
}

export default FooterLegal;
